export default __webpack_public_path__ + "static/providervalue-1048f77049b639626755976b12533d94.jpg";